import { fun_PostAction } from "@/api/index";
// 引入转译方法
import { fun_GetKeys } from "@/utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        corpName: null, // 企业名称
        certTypeNum: null, // 资质资格类型
        certId: null, // 证书编号
        organName: null, // 发证机关
        isValid: null, // 证书状态
        organDate: null, // 发证日期
        state: null // 状态
      },
      // 查询表单
      formSearchList: [
        // {
        //   type: "input",
        //   label: "企业名称：",
        //   value: "corpName",
        //   placeholder: "请输入"
        // },
        {
          type: "select",
          label: "资质资格类型：",
          value: "certTypeNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131554050002"
          }
        },
        {
          type: "input",
          label: "证书编号：",
          value: "certId",
          placeholder: "请输入"
        },
        // {
        //   type: "input",
        //   label: "发证机关：",
        //   value: "organName",
        //   placeholder: "请输入"
        // },
        // {
        //   type: "select",
        //   label: "证书状态：",
        //   value: "isValid",
        //   placeholder: "请输入",
        //   queryParams: {
        //     url: "/dataDictionaryEntries/BasicDataCombobox",
        //     zdid: "201507131619050031"
        //   }
        // },
        // {
        //   type: "date",
        //   label: "发证日期：",
        //   value: "organDate",
        //   valueFormat: "yyyy-MM-dd",
        //   placeholder: "请输入"
        // },
        {
          type: "select",
          label: "状态：",
          value: "state",
          placeholder: "请输入",
          optionData: [
            { name: "保存", value: "bc" },
            { name: "提交", value: "tj" },
            { name: "通过", value: "tg" },
            { name: "退回", value: "th" }
          ]
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "资质资格类型",
          prop: "certTypeName",
          isShow: true
        },
        {
          label: "状态",
          slotName: "state",
          width: 100
        },
        {
          label: "证书编号",
          prop: "certId",
        },
        {
          label: "资质资格最高等级",
          prop: "titleLevelName",
        },
        {
          label: "发证机关",
          prop: "organName"
        },
        {
          label: "发证日期",
          prop: "organDate"
        },
        // {
        //   label: "证书有效期截止日期",
        //   prop: "endDate"
        // },
        {
          label: "证书状态",
          prop: "isValidName"
        }
      ],
      // 表格数据
      tableData: [],
      // 用户标识
      userFlag: sessionStorage.getItem("userFlag"),
      // 用户类型
      loginType: sessionStorage.getItem("loginType"),
      // 勾选数组
      multipleSelection: []
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 用户类型为工作人员或监管人员时
    if (this.userFlag === "工作人员" || this.userFlag === "监管人员") {
      // 清空表头
      this.btnList = [];
      // 取消资质资格类型点击状态
      this.tableColumns[0].isShow = false;
      // 添加企业名称
      this.tableColumns.splice(0, 0, {
        label: "企业名称",
        prop: "corpName",
        isShow: true
      });
    } else {
      // 遍历查询表单
      this.formSearchList.forEach(e => {
        // 如果是企业名称
        if (e.value === "corpName") {
          // 置灰
          e.disabled = true;
        }
      });
    }
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction("/corpCertinfo/list", {
          ...this.form,
          ...this.reqPageData
        },60000).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.loading = false;
            // 回显table
            this.tableData = data.data.records;
            // 获取分页总条数
            this.total = data.data.total;
            // 用户类型为工作人员或监管人员时
            if (this.userFlag === "工作人员" || this.userFlag === "监管人员") {
              this.form.corpName = null;
            }else{
              // 企业名称
              this.form.corpName = data.corpName;
            }
          } else {
            // 关闭loading
            this.loading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框点击事件
     */
    fun_GetSelectVal(e, i) {
      // 核验状态
      if (i === "certTypeNum") {
        // 赋值
        this.form.certTypeNum = e;
      } else if (i === "isValid") {
        // 赋值
        this.form.isValid = e;
      } else if (i === "state") {
        // 赋值
        this.form.state = e;
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 判断是否为工作人员
      if(sessionStorage.getItem("userFlag") === "工作人员"){
        // 跳转详情页面
        this.$router.push({
          path: "/corpCertinfoDetail",
          query: {
            type: "details",
            id: e.val.id,
          }
        });
        return false;
      }
      // 子传父
      this.$emit("fun_Details", "corpCertinfoDetails", {
        id: e.val.id,
        type: "details"
      });
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 子传父
      this.$emit("fun_Details", "corpCertinfoDetails", { type: "insert" });
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 子传父
          this.$emit("fun_Details", "corpCertinfoDetails", {
            id: this.multipleSelection[0].id,
            type: "update"
          });
        }
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 删除
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 弹出询问confirm
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 获取keys
          const keys = fun_GetKeys(this.multipleSelection);
          // 发起请求，获取结果集
          fun_PostAction("/corpCertinfo/delete?keys=" + keys).then(res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 判断请求是否成功
            if (result) {
              // 查询列表
              this.fun_GetList();
              // 提示删除成功
              this.$message.success(msg);
            } else {
              // 请求失败，提示信息
              this.$message.error(msg);
            }
          });
        });
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },

    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
